import * as React from "react";
import { Navigate, Route } from "react-router";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";
import { SaleRedirect } from "./SalesHistory/SaleRedirect";

const ManageCash = React.lazy(() => import("./ManageCash/ManageCash"));
const CloseRegister = React.lazy(() => import("./CloseRegister/CloseRegister"));
const SalesHistory = React.lazy(() => import("./SalesHistory/SalesHistory"));

export default function RegisterIndex(): Array<React.ReactNode> {
    return [
        <PermissionRoute
            permissions={[ "see_history" ]}
            title="Sales History | Shopfront"
            path="/history"
            key="sales-history"
            element={<SalesHistory />}
        />,
        <PermissionRoute
            permissions={[ "manage_takings_adjust_movement" ]}
            title="Manage Takings | Shopfront"
            path="/manage-cash"
            key="manage-cash"
            element={<ManageCash />}
        />,
        <PermissionRoute
            permissions={[ "see_manage_takings" ]}
            title="Close Register | Shopfront"
            path="/close"
            key="close-register"
            element={<CloseRegister />}
        />,
        <Route
            path="/takings"
            key="takings-close-register-redirect"
            element={<Navigate to="/close" replace />}
        />,
        <Route
            path="/sale/:id"
            key="single-sale-redirect"
            element={<SaleRedirect />}
        />,
    ];
}
